import * as React from 'react'
function SvgTagEmpty(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M18 4c.6 0 1 .2 1.4.6l16 16c.8.8.8 2 0 2.8l-12 12c-.4.4-.8.6-1.4.6-.6 0-1-.2-1.4-.6l-16-16C4.2 19 4 18.6 4 18V6c0-1.2.8-2 2-2zm-.8 4H8v9.2l14 14 9.2-9.2-14-14zM14 12a2 2 0 110 4 2 2 0 010-4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgTagEmpty
